import React, { useEffect, useState } from "react";
import { openCounters, savedCounters } from "./displayedCounters";

const InnerListBox = ({ box }) => {
  const [displays, setDisplays] = useState([]);
  const obj = {
    open: openCounters,
    saved: savedCounters,
  };

  function handleDisplayedCounters() {
    const counters = obj[box.collection](box);
    setDisplays(counters);
  }

  useEffect(() => {
    handleDisplayedCounters();
  }, [box]);

  return (
    <div className="divRow" style={{ flex: 1, justifyContent: "space-around" }}>
      {displays.map((d) => (
        <DisplayHolder {...d} key={d.description} />
      ))}
    </div>
  );
};

const DisplayHolder = ({ icon, counter, description }) => {
  return (
    <div className="divColumn">
      <div className="divRow">
        <img src={icon} className="icon25" />
        <div className="textBold">{counter}</div>
      </div>
      <div className="textBlack" style={{ fontSize: "13px" }}>
        {description}
      </div>
    </div>
  );
};

export default InnerListBox;
